// extracted by mini-css-extract-plugin
export default {"root":"Q5WWQNnz"};